import React, { useState } from 'react';
import GenericModal from '../../../components/modal/GenericModal';
import AsyncSelectInput from '../../../components/Select/AsyncSelectInput';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';
import {
    reasignarResponsableConvocatoriaAPI,
    getResponsableEmpleadoWithoutReserverdPeopleWordTypeAPI,
} from '../../../consumers/backendApisUrls';

// ──────────────────────────────────────────────────────────────────────────
// Modal "Reasignar responsable" de una convocatoria (Pieza C).
// Actualiza TP_Convocatoria.IdEmpleadoResponsable vía
// POST TrasladosPromociones/ReasignarResponsable/{id}.
// Patrón tomado de Documentos/ListaDistribucionDocumentos/ReasignarResponsable.
// ──────────────────────────────────────────────────────────────────────────
const ReasignarResponsableModal = ({ toggleModal, refreshPage, row }) => {
    const [managePostRequest] = useManagePostRequest();
    const [nuevoResponsable, setNuevoResponsable] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = () => {
        if (!nuevoResponsable?.value) return;
        if (isSubmitting) return;
        setIsSubmitting(true);
        const payload = { IdEmpleadoResponsable: nuevoResponsable.value };
        managePostRequest(
            reasignarResponsableConvocatoriaAPI(row.idConvocatoria),
            payload,
            (response) => {
                setIsSubmitting(false);
                toggleModal();
                refreshPage && refreshPage();
            },
            true,
            () => setIsSubmitting(false),
            true
        );
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Reasignar responsable" width="600px">
            <div className="modal-body">
                <div className="form-group">
                    <label className="modal-label mb-0">Responsable actual</label>
                    <input type="text" className="form-control" value={row.nombreEmpleadoResponsable ?? ""} disabled />
                </div>
                <div className="form-group">
                    <label className="modal-label mb-0">Nuevo responsable</label>
                    <AsyncSelectInput
                        api={getResponsableEmpleadoWithoutReserverdPeopleWordTypeAPI}
                        handleSelectInputChange={setNuevoResponsable}
                        defaultValue={nuevoResponsable}
                        placeholder="Buscar nuevo responsable..."
                    />
                </div>
                <div className="modal-footer pl-0">
                    <div />
                    <button
                        type="button"
                        className="generic-button-buscador generic-button-hover-verde green-innova-background"
                        onClick={handleSubmit}
                        disabled={isSubmitting}>
                        Guardar
                    </button>
                </div>
            </div>
        </GenericModal>
    )
}

export default ReasignarResponsableModal
